import React from 'react';
import { Facebook, Instagram, Youtube, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-prt-dark text-white py-16" data-id="element-1">
      <div className="container mx-auto px-6 flex flex-col items-center text-center" data-id="element-2">
        <div className="w-24 h-24 mb-8 rounded-full bg-white/5 flex items-center justify-center p-2" data-id="element-3">
          <img src="https://cdn.magicpatterns.com/uploads/hgMw6coYeViNRp9G1BXrEW/New_PRT_Logo.png" alt="PRT Logo" className="w-full h-full object-contain" data-id="element-4" />
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-5">
          <a href="#about" className="hover:text-prt-blue transition-colors uppercase tracking-wider text-sm font-medium" data-id="element-6">
            About
          </a>
          <a href="#classes" className="hover:text-prt-blue transition-colors uppercase tracking-wider text-sm font-medium" data-id="element-7">
            Classes
          </a>
          <a href="#training" className="hover:text-prt-blue transition-colors uppercase tracking-wider text-sm font-medium" data-id="element-8">
            Training
          </a>
          <a href="#contact" className="hover:text-prt-blue transition-colors uppercase tracking-wider text-sm font-medium" data-id="element-9">
            Contact
          </a>
        </div>

        <div className="flex gap-6 mb-12" data-id="element-10">
          <a href="#" className="w-11 h-11 rounded-full bg-prt-surface flex items-center justify-center text-prt-blue hover:bg-prt-blue hover:text-white transition-colors" data-id="element-11">
            <Facebook size={20} data-id="element-12" />
          </a>
          <a href="#" className="w-11 h-11 rounded-full bg-prt-surface flex items-center justify-center text-prt-blue hover:bg-prt-blue hover:text-white transition-colors" data-id="element-13">
            <Instagram size={20} data-id="element-14" />
          </a>
          <a href="#" className="w-11 h-11 rounded-full bg-prt-surface flex items-center justify-center text-prt-blue hover:bg-prt-blue hover:text-white transition-colors" data-id="element-15">
            <Youtube size={20} data-id="element-16" />
          </a>
          <a href="#" className="w-11 h-11 rounded-full bg-prt-surface flex items-center justify-center text-prt-blue hover:bg-prt-blue hover:text-white transition-colors font-bold" data-id="element-17">
            Yelp
          </a>
        </div>

        <p className="text-prt-muted text-sm" data-id="element-18">
          Copyright © 2024 Potential Realized Training — All Rights Reserved.
        </p>
      </div>
    </footer>;
}